export const snackbarKeys = {
  approveErc1155: 'approveErc1155',
  approveErc20: 'approveErc20',
}
